// extracted by mini-css-extract-plugin
export default {"borderColor":"#e8e8e8","secondaryFontColor":"#999","primaryFontColor":"#000","backShade":"#f9f9f9","smallBP":"(max-width: 768px)"};